import React from 'react';
import styled from 'styled-components';
import { GroupMemberTagData } from '../../shared/dto/EntityRepository';
import { useGroupMemberStore } from '../../shared/store/groupMemberStore';

interface GroupMemberLabelInViewerProps {
  memberId: string;
  memberLabels: GroupMemberTagData[];
  label: GroupMemberTagData;
}

const GroupMemberLabelInViewer: React.FC<GroupMemberLabelInViewerProps> = ({
  memberId,
  memberLabels,
  label,
}) => {
  const updateGroupMemberLocal = useGroupMemberStore((s) => s.updateGroupMemberLocal);
  const isOnMember = memberLabels.some((each) => each.id === label.id);

  const handleToggle = () => {
    const nextLabels = isOnMember
      ? memberLabels.filter((each) => each.id !== label.id)
      : [...memberLabels, label];
    updateGroupMemberLocal(memberId, { tags: nextLabels });
  };

  return (
    <LabelItem $isActive={isOnMember} onClick={handleToggle}>
      {label.name}
    </LabelItem>
  );
};

export default GroupMemberLabelInViewer;

const LabelItem = styled.div<{ $isActive: boolean }>`
  width: fit-content;
  border-bottom: 1px dotted
    ${({ $isActive, theme }) =>
      $isActive ? theme.colors.color_Gray_03 : 'transparent'};
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.color_Gray_03 : theme.colors.color_Gray_04};
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.5)};
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(0.95);
  }
`;
